import { RCPOFilter } from '../hooks/use-rcpo-data'
import { FiltersQuery } from '@generated'

// Make sure we can keep showing the intial filters,
// by merging the initial filters with the newly available filters from the latest query
// this way we can disable the filters that are not available anymore without losing the initial filters
export function getMergedArticleFilters(
  initialFilters: FiltersQuery,
  filteredFilters: FiltersQuery,
): RCPOFilter[] {
  // 57 = MemberOnlyDiscount, can ignore for RCPO
  const withoutUnwantedFilters =
    initialFilters?.filters?.articleAttributeFilters?.filter((item) => item?.attributeID !== 57) ||
    []

  return (
    (withoutUnwantedFilters.map((defaultFilter) => {
      const filter = filteredFilters?.filters?.articleAttributeFilters?.find(
        (f) => f?.attributeID === defaultFilter?.attributeID,
      )
      return {
        ...defaultFilter,
        articleFilterAttributeValues: defaultFilter?.articleFilterAttributeValues?.map((value) => ({
          ...value,
          isAvailable: filter
            ? filter?.articleFilterAttributeValues?.some(
                (f) => f?.attributeValueID === value?.attributeValueID,
              )
            : false,
        })),
      }
    }) as RCPOFilter[]) ?? []
  )
}
